export default defineNuxtPlugin(function () {
  var _useNuxt2App = useNuxt2App(),
    $vsf = _useNuxt2App.$vsf;
  var axios = $vsf.$ct.client;
  axios.defaults.withCredentials = true;
});